import { useState, useEffect } from 'react';
import { Box, Flex, Text, useDisclosure, useColorModeValue } from '@chakra-ui/react';
import Sidebar, { SIDEBAR_WIDTH, SIDEBAR_COLLAPSED_WIDTH } from './Sidebar';
import Header from './Header';
import ReadOnlyBanner from '../common/ReadOnlyBanner';
import packageJson from '../../../package.json';

const SIDEBAR_COLLAPSED_KEY = 'sidebar-collapsed';

function Layout({ children }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const bgColor = useColorModeValue('gray.50', 'gray.900');
  const footerTextColor = useColorModeValue('gray.500', 'gray.500');
  const footerBorderColor = useColorModeValue('gray.200', 'gray.700');
  const currentYear = new Date().getFullYear();

  // Initialize collapsed state from localStorage
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const stored = localStorage.getItem(SIDEBAR_COLLAPSED_KEY);
    return stored === 'true';
  });

  // Persist collapsed state to localStorage
  useEffect(() => {
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(isCollapsed));
  }, [isCollapsed]);

  const handleToggleCollapse = () => {
    setIsCollapsed(prev => !prev);
  };

  const sidebarWidth = isCollapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH;

  return (
    <Flex minH="100vh" bg={bgColor}>
      <Sidebar
        isOpen={isOpen}
        onClose={onClose}
        isCollapsed={isCollapsed}
        onToggleCollapse={handleToggleCollapse}
      />
      <Box
        flex="1"
        ml={{ base: 0, md: `${sidebarWidth}px` }}
        transition="margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
      >
        <Header onOpenSidebar={onOpen} />
        <ReadOnlyBanner />
        <Box
          as="main"
          p={{ base: 4, md: 6, lg: 8 }}
          minH="calc(100vh - 130px)"
        >
          {children}
        </Box>
        <Box
          as="footer"
          py={4}
          px={{ base: 4, md: 6, lg: 8 }}
          borderTop="1px solid"
          borderColor={footerBorderColor}
        >
          <Flex
            justify="space-between"
            align="center"
            flexWrap="wrap"
            gap={2}
          >
            <Text fontSize="sm" color={footerTextColor}>
              &copy; {currentYear} StatFalcon. All rights reserved.
            </Text>
            <Text fontSize="sm" color={footerTextColor}>
              v{packageJson.version}
            </Text>
          </Flex>
        </Box>
      </Box>
    </Flex>
  );
}

export default Layout;
